import 'css-chunk:src/feature/provision/ProvisionItemCta.module.scss';export default {
  "root": "ProvisionItemCta_root"
};